const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/bbd11f870587f50d39517dcce270c0a6.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 w-full">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Tu hogar en <span className="text-teal-400">las mejores manos</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Nos ocupamos de las tareas de tu hogar y del cuidado de los tuyos, permitiéndote disfrutar de tu tiempo libre. Servicios profesionales en toda la isla de Gran Canaria.
          </p>
          <button
            onClick={scrollToContact}
            className="bg-teal-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
          >
            <span>Solicita tu presupuesto gratis</span>
            <i className="ri-arrow-right-line"></i>
          </button>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">+12.500</div>
              <div className="text-sm text-white/80">Hogares atendidos</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">+8</div>
              <div className="text-sm text-white/80">Años de experiencia</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">150+</div>
              <div className="text-sm text-white/80">Profesionales</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 border border-white/20">
              <div className="text-3xl font-bold text-white mb-1">4.9</div>
              <div className="text-sm text-white/80">Valoración media</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
};

export default HeroSection;